"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var abstract_criterion_1 = require("./abstract-criterion");
/**
 * Above all commons facilitates basic features of a criterion denoting a range with minimal and maximal values.
 */
var AbstractCriterionRange = /** @class */ (function (_super) {
    __extends(AbstractCriterionRange, _super);
    /**
     * Constructs the range with initial parameters.
     * @param {FilterItem} filterItem - The item hosting this particular criteria.
     * @param {boolean} isNegating - Whether the associated filtering method is negating.
     * @param {!boolean} _isIncluding - Whether the range boundaries are included.
     * @param {!RangeBounding} _bounding - Whether the range is bounded and if yes then from which side.
     * @param {!T} _valueFrom - The minimal value.
     * @param {!T} _valueTo - The maximal value.
     * @see FilterType
     * @see FilterTypeNegations
     */
    function AbstractCriterionRange(filterItem, isNegating, _isIncluding, _bounding, _valueFrom, _valueTo) {
        if (_isIncluding === void 0) { _isIncluding = false; }
        if (_bounding === void 0) { _bounding = null; }
        if (_valueFrom === void 0) { _valueFrom = null; }
        if (_valueTo === void 0) { _valueTo = null; }
        var _this = _super.call(this, filterItem, isNegating) || this;
        _this._isIncluding = _isIncluding;
        _this._bounding = _bounding;
        _this._valueFrom = _valueFrom;
        _this._valueTo = _valueTo;
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(_isIncluding);
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(_bounding);
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(_valueFrom);
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(_valueTo);
        return _this;
    }
    Object.defineProperty(AbstractCriterionRange.prototype, "isIncluding", {
        /**
         * Check whether the range values are included in the range.
         * @returns {boolean} True if they are, false otherwise.
         */
        get: function () {
            return this._isIncluding;
        },
        /**
         * Specify whether the range values are included in the range.
         * @param {boolean} isIncluding - True if they are, false otherwise.
         */
        set: function (isIncluding) {
            this._isIncluding = isIncluding;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractCriterionRange.prototype, "bounding", {
        /**
         * Check if the lower or upper values of the range are fixed - the range is bounded - or not in which case the value
         * is not specified (null).
         * @returns {RangeBounding} The bounding type if any.
         */
        get: function () {
            return this._bounding;
        },
        /**
         * Specify if the lower or upper values of the range are fixed - the range is bounded - or not in which case the value
         * is not specified (null).
         * @param {RangeBounding} bounding - The bounding type if any.
         */
        set: function (bounding) {
            this._bounding = bounding;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractCriterionRange.prototype, "valueFrom", {
        /**
         * Accessor to get the property.
         * @returns {T} The lower value.
         */
        get: function () {
            return this.getValueFrom();
        },
        /**
         * Accessor to set the property.
         * @param {T} valueFrom - The lower value.
         */
        set: function (valueFrom) {
            this.setValueFrom(valueFrom);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractCriterionRange.prototype, "valueTo", {
        /**
         * Accessor to get the property.
         * @returns {T} The upper value.
         */
        get: function () {
            return this.getValueTo();
        },
        /**
         * Accessor to set the property.
         * @param {T} valueTo - The upper value.
         */
        set: function (valueTo) {
            this.setValueTo(valueTo);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Getter method (not accessor) to be overridden in descendants if needed.
     * @returns {T} The lower value.
     */
    AbstractCriterionRange.prototype.getValueFrom = function () {
        return this._valueFrom;
    };
    /**
     * Setter method (not accessor) to be overridden in descendants if needed. Each time the value is changed criterion
     * is validated.
     * @param {T} valueFrom - The lower value.
     */
    AbstractCriterionRange.prototype.setValueFrom = function (valueFrom) {
        this._valueFrom = valueFrom;
        this.validate();
    };
    /**
     * Getter method (not accessor) to be overridden in descendants if needed.
     * @returns {T} The upper value.
     */
    AbstractCriterionRange.prototype.getValueTo = function () {
        return this._valueTo;
    };
    /**
     * Setter method (not accessor) to be overridden in descendants if needed. Each time the value is changed criterion
     * is validated.
     * @param {T} valueTo - The upper value.
     */
    AbstractCriterionRange.prototype.setValueTo = function (valueTo) {
        this._valueTo = valueTo;
        this.validate();
    };
    return AbstractCriterionRange;
}(abstract_criterion_1.AbstractCriterion));
exports.AbstractCriterionRange = AbstractCriterionRange;
//# sourceMappingURL=abstract-criterion-range.js.map